'use client';

import Button from 'components/buttons/button';
import signout from 'images/icons/log-out.svg';
import { signIn, signOut, useSession } from 'next-auth/react';
import { usePostHog } from 'posthog-js/react';

interface LogoutButtonProps {
  style?: 'text';
}

export const LogoutButton = ({ style }: LogoutButtonProps) => {
  const isTextStyle = style === 'text';
  const { data: session } = useSession();
  const posthog = usePostHog();
  const isLoggedIn = !!session?.user;

  return isLoggedIn ? (
    isTextStyle ? (
      <button
        type="button"
        className="flex anchor-subtle gap-1 font-normal"
        onClick={() => {
          posthog.reset();
          signOut();
        }}
      >
        Sign Out
      </button>
    ) : (
      <Button
        theme={'link'}
        className="button-navigation flex w-full items-center gap-1 font-normal text-stone-600 no-underline dark:text-stone-400"
        iconSrc={signout}
        onClick={() => {
          posthog.reset();
          signOut();
        }}
      >
        Sign Out
      </Button>
    )
  ) : isTextStyle ? (
    <Button
      theme={'link'}
      className="flex anchor-subtle items-center gap-1 font-normal"
      iconSrc={signout}
      onClick={() => {
        signIn();
      }}
    >
      Log In
    </Button>
  ) : (
    <Button
      theme={'link'}
      className="button-navigation flex w-full items-center gap-1 font-normal text-stone-600 no-underline dark:text-stone-400"
      iconSrc={signout}
      onClick={() => {
        signIn();
      }}
    >
      Log In
    </Button>
  );
};
